import { useNoteModal } from 'src/features/notes/NoteModal/noteModalContext';
import {
  useCreateNoteMutation,
  useDeleteNoteMutation,
  useUpdateNoteMutation,
} from 'src/services/api/notesApi';

/**
 * Hook that provides an openNoteModal function for creating/editing notes.
 * Use this when you need to trigger the note modal from outside the Notes component.
 */
export const useOpenNoteModal = ({
  entityType,
  entityId,
}: {
  entityType: 'client' | 'company';
  entityId: string;
}) => {
  const [createNote] = useCreateNoteMutation();
  const [updateNote] = useUpdateNoteMutation();
  const [deleteNote] = useDeleteNoteMutation();

  const openNoteModal = useNoteModal({
    onDelete: async (note) => {
      await deleteNote({
        id: note.id,
        entityType: note.entityType,
        entityId: note.entityId,
      });
    },
    onSave: (title, content, note) => {
      if (note) {
        updateNote({
          id: note.id,
          title,
          content,
          entityType: note.entityType,
          entityId: note.entityId,
        });
      } else {
        createNote({
          entityType,
          entityId,
          title,
          content,
        });
      }
    },
  });

  return openNoteModal;
};
